import { Get, Post, Jsonp, GetWithAuth, PostWithAuth, Put, PutWithAuth, PatchWithAuth, DeleteWithAuth } from '@/modules/requester/index'
import config from '@/config'
import store from '@/store'

const getBaseURL = () => store.getters.domainSettings.BackendServiceUrl || config.base_urls.API_BASE_URL
const getIdentityServerURL = () => store.getters.domainSettings.IdentityServer
const getGraphApiUrl = () => store.getters.domainSettings.FacebookGraphApiPath

export default {
  oldSystem: {
    signIn (payload) {
      return Post('https://auth.app-controller.net/api/AccountMethods/SignIn', payload).then(response => response.json())
    },
    saveToken (payload) {
      return Post('https://designer_api.app-controller.net/api/ClientsExtension/SaveClientToken', payload).then(response => response.json())
    },
    saveActivityLog (payload) {
      return Post('https://designer_api.app-controller.net/api/ActivityLog', payload).then(response => response.json())
    }
  },
  system: {
    getDomainSettings (payload) {
      return Post(getBaseURL() + 'SystemTableTYABrandings', payload).then(response => response.json())
    },
    getAppTemplatesCategories (lang) {
      return Get(getBaseURL() + `SystemTableAppTemplatesCategories/${lang}`).then(response => response.json())
    },
    getAppTemplatesApps (lang) {
      return Get(getBaseURL() + `SystemTableAppTemplatesApps/${lang}`).then(response => response.json())
    },
    getResource (language, time) {
      return Get(`/static/res/lan-${language}.json?d=${time}`).then(response => response.json())
    },
    getThemesBackgroundColors (lang) {
      return GetWithAuth(getBaseURL() + `SystemTableThemesBackgroundColorsAuth?id=${lang}`, store.getters.user.Token).then(response => response.json())
    },
    getAppThemes () {
      return GetWithAuth(getBaseURL() + 'SystemTableThemesAppThemesAuth', store.getters.user.Token).then(response => response.json())
    },
    getTextureImages () {
      return GetWithAuth(getBaseURL() + 'SystemTextureImagesAuth', store.getters.user.Token).then(response => response.json())
    },
    getAvailableFonts () {
      return GetWithAuth(getBaseURL() + 'SystemTableFontGalleryAuth', store.getters.user.Token).then(response => response.json())
    },
    getCountriesInfo (lang = 'de') {
      return GetWithAuth(getBaseURL() + `SystemTableCountries?id=${lang}`, store.getters.user.Token).then(response => response.json())
    },
    getSubscriptionModules (lang = 'de') {
      return GetWithAuth(getBaseURL() + `SystemTableSubscriptionModulesAuth/${lang}`, store.getters.user.Token).then(response => response.json())
    },
    getPostTemplate (moduleId, lang = 'de') {
      return GetWithAuth(getBaseURL() + `SystemTableModuleTemplatesContentPagesNewPostTemplatesAuth/GetPostTemplate/${lang}/${moduleId}`, store.getters.user.Token).then(response => response.json())
    },
    logError (payload) {
      return Post(getBaseURL() + 'SystemTableTYAErrorLog', payload).then(response => response.json())
    },
    activityLog (payload) {
      return Post(getBaseURL() + 'ActivityLog', payload).then(response => response.json())
    },
    GetIpInfo () {
      return Get(getBaseURL() + 'IPDeviceInfo/GetIp').then(response => response.json())
    },
    Get (paylod) {
      return Get(paylod).then(response => response.json())
    },
    currentTime () {
      return Get(getBaseURL() + 'ActivityLog/CurrentDate').then(response => response.json())
    }
  },
  user: {
    signIn (payload) {
      return Post(getIdentityServerURL() + 'SignIn', payload).then(response => response.json())
    },
    isUserValid (payload) {
      return Post(getIdentityServerURL() + 'IsUserValid', payload).then(response => response.json())
    },
    orderSignIn (payload) {
      return Post(getIdentityServerURL() + 'OrderSignIn', payload).then(response => response.json())
    },
    changePassword (payload) {
      return Post(getIdentityServerURL() + 'ChangePassword', payload)
    },
    resetPassword (payload) {
      return Post(getIdentityServerURL() + 'ForgotDetails', payload)
    },
    saveToken (payload) {
      return Post(getBaseURL() + 'ClientsExtension/SaveClientToken', payload).then(response => response.json())
    },
    apps (payload) {
      return PostWithAuth(getBaseURL() + 'AppsAuth/MyApps', payload, store.getters.user.Token).then(response => response.json())
    },
    changeEmail (payload) {
      return PostWithAuth(getBaseURL() + 'ClientsExtensionAuth/ChangeEmail', payload, store.getters.user.Token)
    },
    deActiveAccount () {
      return PostWithAuth(getBaseURL() + 'ClientsExtensionAuth/DeActivateAccount', '', store.getters.user.Token)
    },
    cancelAccount (payload) {
      return PostWithAuth(getBaseURL() + 'ClientsExtensionAuth/DeleteAccount', payload, store.getters.user.Token).then(response => response.json())
    },
    cancelAccountWithChargeBee (payload) {
      return PostWithAuth(getBaseURL() + 'ChargeBee/ChargeBeeCancelAllSubscriptionOnPortal', payload, store.getters.user.Token).then(response => response.json())
    },
    getClientInfo (clientId) {
      return Get(getBaseURL() + `ClientsExtension/Get?id=${clientId}`).then(response => response.json())
    },
    updateClientAddress (payload) {
      return Put(getBaseURL() + 'Clients', payload)
    },
    generateActivePIN (payload) {
      return Post(getBaseURL() + 'Clients/GetVerificationCode', payload).then(response => response.json())
    },
    VerifyActivePinCode (payload) {
      return Post(getBaseURL() + 'Clients/VerifyActivePinCode', payload).then(response => response.json())
    }
  },
  subscription: {
    getDesignSettings (subscriptionId) {
      return GetWithAuth(getBaseURL() + `SubscriptionsAuth/SubscriptionsDesignSettings?id=${subscriptionId}`, store.getters.user.Token).then(response => response.json())
    },
    getStartPage (subscriptionId) {
      return GetWithAuth(getBaseURL() + `SubscriptionsStartPagesAuth?id=${subscriptionId}`, store.getters.user.Token).then(response => response.json())
    },
    getModules (subscriptionId) {
      return GetWithAuth(getBaseURL() + `SubscriptionsModulesAuth?id=${subscriptionId}`, store.getters.user.Token).then(response => response.json())
    },
    updateMenuLabel (payload) {
      return PutWithAuth(getBaseURL() + `SubscriptionsModulesAuth/UpdateModuleLabel`, payload, store.getters.user.Token).then(response => response.json())
    },
    updateHideModule (payload) {
      return PutWithAuth(getBaseURL() + `SubscriptionsModulesAuth/UpdateModuleLabel`, payload, store.getters.user.Token).then(response => response.json())
    },
    setModulePassword (payload) {
      return PostWithAuth(getBaseURL() + `SubscriptionsModulesAuth/AddModulePassword`, payload, store.getters.user.Token)
    },
    saveStartPage (payload) {
      return PostWithAuth(getBaseURL() + 'SubscriptionsStartPagesAuth', payload, store.getters.user.Token)
    },
    patchStartPage (id, payload) {
      return PatchWithAuth(getBaseURL() + 'SubscriptionsStartPagesAuth?id=' + id, payload, store.getters.user.Token).then(response => response.json())
    },
    saveModules (payload) {
      return PostWithAuth(getBaseURL() + 'SubscriptionsModulesAuth/AddModules', payload, store.getters.user.Token)
    },
    addSubscriptionsModule (payload) {
      return PostWithAuth(getBaseURL() + 'SubscriptionsModulesAuth/AddModule', payload, store.getters.user.Token)
    },
    deleteSubscriptionsModule (Id) {
      return DeleteWithAuth(getBaseURL() + 'SubscriptionsModulesAuth?id=', Id, store.getters.user.Token)
    },
    createApp (payload) {
      return Post(getBaseURL() + 'Subscriptions', payload).then(response => response.json())
    },
    updateSubscription (payload) {
      return PutWithAuth(getBaseURL() + `SubscriptionsAuth`, payload, store.getters.user.Token)
    },
    getSubscriptionProducts (language) {
      return GetWithAuth(`${getBaseURL()}SystemTableBillingProductsAuth/GetBySubscriptionsProducts/${language}`, store.getters.user.Token).then(response => response.json())
    },
    deleteSubscription (payload) {
      return PostWithAuth(getBaseURL() + 'SubscriptionsAuth/DeleteSubscription', payload, store.getters.user.Token).then(response => {
        return response.status
      }).catch(err => {
        return err.status
      })
    },
    deleteSubscriptionWithChargebee (payload) {
      return PostWithAuth(getBaseURL() + 'ChargeBee/ChargeBeeCancelSingleSubscriptionOnPortal', payload, store.getters.user.Token).then(response => {
        return response.status
      }).catch(err => {
        return err.status
      })
    },
    getNestedModules (subscriptionId) {
      return GetWithAuth(getBaseURL() + 'ModuleNavigationAuth/' + subscriptionId, store.getters.user.Token).then(response => response.json())
    },
    updateLastAccess (subscriptionId) {
      return GetWithAuth(getBaseURL() + `SubscriptionsExtensionAuth/UpdateLastAccess/${subscriptionId}`, store.getters.user.Token)
    },
    updateLastPublishingProcessStartDate (subscriptionId) {
      return PostWithAuth(`${getBaseURL()}SubscriptionsExtensionAuth/UpdateLastPublishingDate?id=${subscriptionId}`, store.getters.user.Token).then(response => response.json())
    },
    saveAppDesignSettings (payload) {
      return PostWithAuth(getBaseURL() + 'AppDesignSettingsAuth', payload, store.getters.user.Token)
    }
    // saveDesignSettings (payload) {
    //   return Post(getBaseURL() + 'SubscriptionsDesignSettings', payload)
    // },
  },
  image: {
    upload (payload) {
      return PostWithAuth(getBaseURL() + 'ImageServicesAuth/GalleyUpload', payload, store.getters.user.Token).then(response => response.json())
    },
    delete (payload) {
      return PostWithAuth(getBaseURL() + 'ImageServicesAuth/DeleteImage', payload, store.getters.user.Token).then(response => response.json())
    },
    multipleUpload (payload) {
      return PostWithAuth(getBaseURL() + 'ImageServicesAuth/GalleysUpload', payload, store.getters.user.Token).then(response => response.json())
    },
    pixabay (payload) {
      return Get(config.base_urls.PIXABAY_API_BASE_URL, payload)
    },
    WriteCustomCodeData (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleCustomCodeAuth/WriteCustomCodeData', payload, store.getters.user.Token).then(response => response.json())
    },
    GetDirStructure (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleCustomCodeAuth/GetDirStructure', payload, store.getters.user.Token).then(response => response.json())
    },
    DeleteCustomCodeFile (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleCustomCodeAuth/DeleteCustomCodeFile', payload, store.getters.user.Token).then(response => response.json())
    }
  },
  screenShot: {
    capture (payload) {
      return PostWithAuth(getBaseURL() + 'CaptureAuth', payload, store.getters.user.Token).then(response => response.json())
    }
  },
  Feedback: {
    getSubscriptionsAccountNotificationsData (subscriptioId, lang, notificationtype, skip, fetch) {
      return GetWithAuth(`${getBaseURL()}SubscriptionsAccountNotificationsAuth/${subscriptioId}/${lang}/${notificationtype}/${skip}/${fetch}`, store.getters.user.Token).then(response => response.json())
    },
    deletefeedback (Id) {
      return DeleteWithAuth(getBaseURL() + 'SubscriptionsAccountNotificationsAuth?id=', Id, store.getters.user.Token)
    },
    NotificationCount (Id, notificationtype) {
      return GetWithAuth(`${getBaseURL()}SubscriptionsAccountNotificationsAuth/NotificationCount/${Id}/${notificationtype}`, store.getters.user.Token).then(response => response.data)
    },
    setNotificationSighted (payload) {
      return PostWithAuth(`${getBaseURL()}SubscriptionsAccountNotificationsAuth/SetNotificationSighted`, payload, store.getters.user.Token).then(response => response.data)
    },
    setNotificationProcessed (Id) {
      return PutWithAuth(`${getBaseURL()}SubscriptionsAccountNotificationsAuth/${Id}`, store.getters.user.Token)
    },
    getNotificationsConversations (Id) {
      return GetWithAuth(`${getBaseURL()}SubscriptionsAccountNotificationsConversationsAuth/${Id}`, store.getters.user.Token).then(response => response.data)
    },
    sendNotification (payload) {
      return PostWithAuth(`${getBaseURL()}SubscriptionsAccountNotificationsConversationsAuth/AddSubscriptionsAccountNotificationsConversations`, payload, store.getters.user.Token).then(response => response.json())
    }
  },
  Notification: {
    getnodificationNodes (subscriptioId) {
      return GetWithAuth(`${getBaseURL()}ModuleNavigationAuth?id=${subscriptioId}`, store.getters.user.Token).then(response => response.json())
    },
    sendNoification (payload) {
      return PostWithAuth(getBaseURL() + 'SubscriptionsPushNotificationsAuth', payload, store.getters.user.Token)
    },
    getSightedNotificationCount (subscriptioId) {
      return GetWithAuth(`${getBaseURL()}SubscriptionsAccountNotificationsAuth/SightedNotificationCount/${subscriptioId}`, store.getters.user.Token).then(response => response.json())
    }
  },
  editHistory: {
    processEditHistory (payload) {
      return PostWithAuth(getBaseURL() + 'ImageServicesAuth/ProcessEditHistory', payload, store.getters.user.Token).then(response => response.data)
    }
  },
  icon: {
    getAll (lang) {
      return GetWithAuth(`${getBaseURL()}FolderInfoAuth/AllIconsFolder/${lang}`, store.getters.user.Token).then(response => response.json())
    },
    uploadIcon (payload) {
      return PostWithAuth(getBaseURL() + 'ImageServicesAuth/UploadIcon', payload, store.getters.user.Token).then(response => response.json())
    }
  },
  Order: {
    getBillingProducts (clientId) {
      return Get(`${getBaseURL()}SystemTableBillingProducts/GetClientSubscriptionByClientId/${clientId}`).then(response => response.json())
    },
    getNewBillingProducts (clientId) {
      return Get(`${getBaseURL()}SystemTableBillingProducts/GetNewSubscriptionByClientId/${clientId}`).then(response => response.json())
    },
    getNewPublishingProducts (clientId) {
      return Get(`${getBaseURL()}SystemTableBillingProducts/GetNewPublishingPlanClientId/${clientId}`).then(response => response.json())
    },
    GetOrderProcessApps (payload) {
      return Post(getBaseURL() + 'SubscriptionsExtension/GetOrderProcessApps', payload).then(response => response.json())
    },
    getSubscriptionOffer (currentTimeStamp, clientId) {
      return Get(`${getBaseURL()}/GetSubscriptionOfferByDate/${currentTimeStamp}/${clientId}`).then(response => response.json())
    },
    getSubscriptionLevels () {
      return Get(`${getBaseURL()}SystemTableSubscriptionLevels`).then(response => response.json())
    },
    getSubscriptionData (subscriptionId) {
      return Get(`${getBaseURL()}Subscriptions?id=${subscriptionId}`).then(response => response.json())
    },
    GetModuleinternalInfo (subscriptionId) {
      return Get(`${getBaseURL()}SubscriptionsModules/GetModuleinternalInfo?id=${subscriptionId}`).then(response => response.json())
    },
    updateSubscriptionLavel (data) {
      return Put(getBaseURL() + 'Subscriptions', data).then(response => response.data)
    },
    isUserExist (clientId) {
      return Get(getBaseURL() + `ClientsExtension/CheckUserExistance`).then(response => response.json())
    },
    getSubscriptionsPurchasedProductsData (subscriptionId) {
      return Get(`${getBaseURL()}SubscriptionsPurchasedProducts/${subscriptionId}`).then(response => response.json())
    },
    async IsUserPurchasedProduct (ClientId) {
      let response = await Post(`${getBaseURL()}SubscriptionsPurchasedProducts/IsUserPurchasedProduct?ClientId=${ClientId}`).then(response => response.json())
      return response
    },
    getSystemTableBillingSpecialOffersPricing (Id, language, currency) {
      return Get(`${getBaseURL()}SystemTableBillingSpecialOffersPricing/${Id}/${language}/${currency}`).then(response => response.json())
    },
    async trackOrderProcess (payload) {
      let response = await Post(getBaseURL() + 'TrackOrderProcess', payload).then(response => response.json())
      localStorage.setItem('OrderProcessData', JSON.stringify(response))
    },
    checkVatCode (payload) {
      return Post(getBaseURL() + 'AccountFunctions', payload).then(response => response.json())
    },
    stripeCharge (payload) {
      return Post(getBaseURL() + 'StripeCharge', payload).then(response => response.json())
    },
    SaveSystemTableBillingInvoices (payload) {
      return Post(getBaseURL() + 'SystemTableBillingInvoices', payload).then(response => response.json())
    }
  },
  External: {
    GetCurrentEURExchangerate () {
      return Get(`${config.base_urls.FIXER_API_BASE_URL}latest?base=EUR`).then(response => response.json())
    },
    PaypalPayment (payload) {
      return Get(getBaseURL() + `/Paypal/GetPaymentWithPaypal` + payload).then(response => {
        window.open(response.body, '_self')
      })
    },
    chargeBeePublishing (payload) {
      return Post(getBaseURL() + `/ChargeBee/PublishingWithChargeBee`, payload).then(response => response.json())
    },
    ChargeBeePayment (payload) {
      return Post(getBaseURL() + `/ChargeBee/PaymentWithChargeBee`, payload).then(response => response.json())
    },
    ChargeBeeUpgrade (payload) {
      return Post(getBaseURL() + `/ChargeBee/ChargeBeeCheckoutExisting`, payload).then(response => response.json())
    }
  },
  Analytics: {
    GetOverviewNPlatformInfo (payload) {
      return PostWithAuth(getBaseURL() + 'AppAnalyticsAuth/AnalyticsOverview', payload, store.getters.user.Token).then(response => response.json())
    },
    GetDownloadForMonth (payload) {
      return PostWithAuth(getBaseURL() + 'AppAnalyticsAuth/AppMonthlyDownloads', payload, store.getters.user.Token).then(response => response.json())
    },
    GetDashboardAnalytics (payload) {
      return PostWithAuth(getBaseURL() + 'AppAnalyticsAuth/AppDashboardAnalytics', payload, store.getters.user.Token).then(response => response.json())
    },
    GetDailyAppDownloads (payload) {
      return PostWithAuth(getBaseURL() + 'AppAnalyticsAuth/DailyAppDownloadsForMonth', payload, store.getters.user.Token).then(response => response.json())
    },
    GetDailyPageViews (payload) {
      return PostWithAuth(getBaseURL() + 'AppAnalyticsAuth/DailyPageViewForMonth', payload, store.getters.user.Token).then(response => response.json())
    },
    GetWeeklyPageViews (payload) {
      return PostWithAuth(getBaseURL() + 'AppAnalyticsAuth/GetPageViewsForWeek', payload, store.getters.user.Token).then(response => response.json())
    },
    GetMonthlyPageViews (payload) {
      return PostWithAuth(getBaseURL() + 'AppAnalyticsAuth/GetPageViewsForMonth', payload, store.getters.user.Token).then(response => response.json())
    }
  },
  UserManagment: {
    GetInvitedUsers (payload) {
      return GetWithAuth(getBaseURL() + `SubscriptionsInvitedUsersAuth?id=${payload}`, store.getters.user.Token).then(response => response.json())
    },
    InviteUser (payload) {
      return PostWithAuth(getBaseURL() + 'ClientsExtensionAuth/AddInvitedUsers', payload, store.getters.user.Token)
    },
    UnInviteUser (payload) {
      return DeleteWithAuth(getBaseURL() + 'SubscriptionsInvitedUsersAuth/', payload, store.getters.user.Token)
    }
  },
  AppPublishing: {
    uploadAppleCertificateFile (data) {
      return PostWithAuth(getBaseURL() + 'FtpUploadingUtilityAuth/UploadAppleCertificateFile', data, store.getters.user.Token).then(response => response.data)
    },
    DeleteAppIconImage (payload) {
      return PostWithAuth(getBaseURL() + 'FtpUploadingUtilityAuth/DeleteAppIconImage', payload, store.getters.user.Token).then(response => response.data)
    },
    DeletePulishFile (payload) {
      return PostWithAuth(getBaseURL() + 'FtpUploadingUtilityAuth/DeletePulishFile', payload, store.getters.user.Token).then(response => response.data)
    },
    uploadscreenshotImage (payload) {
      return PostWithAuth(getBaseURL() + 'FtpUploadingUtilityAuth/UploadPulishFile', payload, store.getters.user.Token).then(response => response.data)
    },
    uploadImage (payload) {
      return PostWithAuth(getBaseURL() + 'FtpUploadingUtilityAuth/UploadFile', payload, store.getters.user.Token).then(response => response.data)
    },
    getCreateSplashImage (data) {
      return PostWithAuth(getBaseURL() + 'FolderInfoAuth/CreateImage', data, store.getters.user.Token).then(response => response.data)
    },
    getBackgroundImages () {
      return GetWithAuth(getBaseURL() + 'FolderInfoAuth/GetIconsBackgroundImg', store.getters.user.Token).then(response => response.data)
    },
    saveSubscriptionsConfigurations (payload) {
      return PostWithAuth(getBaseURL() + 'SubscriptionsConfigurationsAuth', payload, store.getters.user.Token).then(response => response.data)
    },
    getSubscriptionConfiguration (payload) {
      return GetWithAuth(getBaseURL() + 'SubscriptionsConfigurationsAuth?id=' + payload, store.getters.user.Token).then(response => response.data)
    },
    getAppPublishingData (data) {
      return GetWithAuth(getBaseURL() + 'AppPublishingAuth?id=' + data, store.getters.user.Token).then(response => response.data)
    },
    saveAppStoreSettings (payload, SubscriptionGUID) {
      return PostWithAuth(getBaseURL() + 'SubscriptionsAppStoreSettingsAuth', payload, store.getters.user.Token).then(response => response.data)
    },
    getISoSigningCertificate (payload) {
      return GetWithAuth(getBaseURL() + 'AppPublishAuth/getIossigningCertificate?strguid=' + payload, store.getters.user.Token).then(response => response.data)
    },
    getSubscriptionsAppStoreSettings (payload) {
      return GetWithAuth(getBaseURL() + 'SubscriptionsAppStoreSettingsAuth?id=' + payload, store.getters.user.Token).then(response => response.data)
    },
    PublishApp (payload) {
      return PostWithAuth(getBaseURL() + 'AppPublishAuth/CreateGoogleAppBackup', payload, store.getters.user.Token).then(response => response.data)
    },
    getAppCategories (payload) {
      return PostWithAuth(getBaseURL() + 'SystemTableAppStoreCategoriesAuth', payload, store.getters.user.Token).then(response => response.json())
    }
  },
  AppModules: {
    GetStreamInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModulesRadioAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    patchStream (Id, payload) {
      return PatchWithAuth(getBaseURL() + `ModulesRadioAuth?id=${Id}`, payload, store.getters.user.Token).then(response => response.json())
    },
    SaveStreamInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesRadioAuth', payload, store.getters.user.Token)
    },
    SaveTeamParent (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesTeamMemberAuth', payload, store.getters.user.Token)
    },
    GetTeamParent (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModulesTeamMemberAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    patchTeamPreson (Id, payload) {
      return PatchWithAuth(getBaseURL() + `ModulesTeamMembersPersonAuth?id=${Id}`, payload, store.getters.user.Token).then(response => response.json())
    },
    GetTeamMembers (ModulesTeamMembersId) {
      return GetWithAuth(getBaseURL() + `ModulesTeamMembersPersonAuth?id=${ModulesTeamMembersId}`, store.getters.user.Token).then(response => response.json())
    },
    SaveTeamPresonInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesTeamMembersPersonAuth', payload, store.getters.user.Token)
    },
    SaveTeamPresonList (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesTeamMembersPersonAuth/AddPersons', payload, store.getters.user.Token)
    },
    DeleteTeamPreson (PresonId) {
      return DeleteWithAuth(getBaseURL() + 'ModulesTeamMembersPersonAuth?id=', PresonId, store.getters.user.Token)
    },
    CopyTeamPresonInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesTeamMembersPersonAuth/CopyMember', payload, store.getters.user.Token)
    },
    getFacebookPageInfo (queryString) {
      return Get(getGraphApiUrl() + queryString).then(response => response.json())
    },
    GetFacebookInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModuleFacebookAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    SaveFacebookInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleFacebookAuth', payload, store.getters.user.Token)
    },
    getTextModule (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModulesContentPageAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    saveTextModule (payload) {
      return PostWithAuth(getBaseURL() + `ModulesContentPageAuth`, payload, store.getters.user.Token)
    },
    patchTextModule (id, payload) {
      return PatchWithAuth(getBaseURL() + 'ModulesContentPageAuth?id=' + id, payload, store.getters.user.Token)
    },
    getTextContentPages (contentPageId) {
      return GetWithAuth(getBaseURL() + `ModulesContentPagesPostAuth?id=${contentPageId}`, store.getters.user.Token).then(response => response.json())
    },
    saveTextContentPage (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesContentPagesPostAuth', payload, store.getters.user.Token)
    },
    copyTextContentPage (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesContentPagesPostAuth/CopyPost', payload, store.getters.user.Token)
    },
    patchTextContentPage (Id, payload) {
      return PatchWithAuth(getBaseURL() + `ModulesContentPagesPostAuth?id=${Id}`, payload, store.getters.user.Token).then(response => response.json())
    },
    saveTextContentPages (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesContentPagesPostAuth/AddPosts', payload, store.getters.user.Token)
    },
    deleteTextContentPage (contentPageId) {
      return DeleteWithAuth(getBaseURL() + 'ModulesContentPagesPostAuth?id=', contentPageId, store.getters.user.Token)
    },
    DeleteContentPageCategory (Id, category) {
      return DeleteWithAuth(getBaseURL() + `ModulesContentPagesPostAuth/DeleteCategory?id=${Id}&category=`, category, store.getters.user.Token)
    },
    getImageGallery (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModulesImageGallerieAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    patchImageGallery (id, payload) {
      return PatchWithAuth(getBaseURL() + 'ModulesImageGallerieAuth?id=' + id, payload, store.getters.user.Token)
    },
    saveImageGalleryModule (payload) {
      return PostWithAuth(getBaseURL() + `ModulesImageGallerieAuth`, payload, store.getters.user.Token)
    },
    getImageGalleriesAlbums (modulesImageGalleriesId) {
      return GetWithAuth(getBaseURL() + `ModulesImageGalleriesAlbumAuth?id=${modulesImageGalleriesId}`, store.getters.user.Token).then(response => response.json())
    },
    saveImageGallerieAlbum (payload) {
      return PostWithAuth(getBaseURL() + `ModulesImageGalleriesAlbumAuth`, payload, store.getters.user.Token).then(response => response.json())
    },
    saveImageGallerieAlbums (payload) {
      return PostWithAuth(getBaseURL() + `ModulesImageGalleriesAlbumAuth/AddAlbums`, payload, store.getters.user.Token)
    },
    copyImageGallerieAlbum (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesImageGalleriesAlbumAuth/CopyAlbum', payload, store.getters.user.Token)
    },
    deleteImageGalleryAlbum (modulesImageGalleriesAlbumId) {
      return DeleteWithAuth(getBaseURL() + 'ModulesImageGalleriesAlbumAuth/', modulesImageGalleriesAlbumId, store.getters.user.Token)
    },
    getImageGalleriesAlbumsImages (modulesImageGalleriesAlbumId) {
      return GetWithAuth(getBaseURL() + `ModulesImageGalleriesAlbumsImageAuth?id=${modulesImageGalleriesAlbumId}`, store.getters.user.Token).then(response => response.json())
    },
    saveImageGallerieAlbumImages (payload) {
      return PostWithAuth(getBaseURL() + `ModulesImageGalleriesAlbumsImageAuth/AddImages`, payload, store.getters.user.Token)
    },
    getFormModule (subscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModulesFormAuth?id=${subscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    saveFormModule (payload) {
      return PostWithAuth(getBaseURL() + 'ModulesFormAuth', payload, store.getters.user.Token)
    },
    patchFormModule (id, payload) {
      return PatchWithAuth(getBaseURL() + 'ModulesFormAuth?id=' + id, payload, store.getters.user.Token)
    },
    GetYoutubeInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModuleYoutubeAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    SaveYoutubeInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleYoutubeAuth', payload, store.getters.user.Token)
    },
    getYoutubeChannel (queryString) {
      return Jsonp(config.base_urls.YOUTUBE_API_BASE_URL + queryString, config.base_urls.DESIGNER_BASE_URL).then(response => response)
    },
    GetRssFeedInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModuleRSSFeedAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    GetRssFeedDate (key) {
      return GetWithAuth(getBaseURL() + `ModuleRSSFeedAuth/GetFeed?feedUrl=${key}`, store.getters.user.Token).then(response => response)
    },
    SaveRssFeedInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleRSSFeedAuth', payload, store.getters.user.Token)
    },
    GetTwitterInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModuleTwitterAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    SaveTwitterInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleTwitterAuth', payload, store.getters.user.Token)
    },
    GetTwitterUserInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleTwitterAuth/UserInformation', payload, store.getters.user.Token).then(response => response.json())
    },
    SearchTwitterUsers (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleTwitterAuth/SearchUser', payload, store.getters.user.Token).then(response => response.json())
    },
    GetWebsiteInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModuleWebsiteAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    WebsiteUrlValid (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleWebsiteAuth/IsUrlValid', payload, store.getters.user.Token).then(response => response)
    },
    SaveWebsiteInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleWebsiteAuth', payload, store.getters.user.Token)
    },
    GetAppAdminList (subscriptionId) {
      return GetWithAuth(getBaseURL() + `SubscriptionsAuth/GetAppAdminList/${subscriptionId}`, store.getters.user.Token).then(response => response.body)
    },
    GetInstagramInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModuleInstagramAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    SaveInstagramInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleInstagramAuth', payload, store.getters.user.Token)
    },
    GetChatModule (SubscriptionModuleId) {
      return Get(getBaseURL() + `ModulesChat?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    SavechatSettings (payload) {
      return Post(getBaseURL() + 'ModulesChat', payload, store.getters.user.Token)
    },
    GetChatMessages (ModulesChatChannelId, date) {
      return Get(getBaseURL() + `ModulesChatAuth/ModulesChatsChannelsMessages/${ModulesChatChannelId}/${date}`).then(response => response.json())
    },
    GetChatMessagesByCount (ModulesChatChannelId, skip, take) {
      return GetWithAuth(getBaseURL() + `ModulesChatAuth/GetMessagesbyCount/${ModulesChatChannelId}/${skip}/${take}`, store.getters.user.Token).then(response => response.json())
    },
    GetLatestChatMessage (ModulesChatChannelId, take, time) {
      return GetWithAuth(getBaseURL() + `ModulesChatAuth/GetLatestModulesChatsChannelsMessages/${ModulesChatChannelId}/${take}`, store.getters.user.Token).then(response => response.json())
    },
    GetChatMessagesCount (ModulesChatChannelId) {
      return Get(getBaseURL() + `ModulesChatAuth/GetModulesChatsListMessageCount/${ModulesChatChannelId}`).then(response => response.json())
    },
    SaveChatChannelInfo (payload) {
      return PostWithAuth(getBaseURL() + `ModulesChatAuth/PostModulesChatsChannels`, payload, store.getters.user.Token).then(response => response.body)
    },
    DeleteChatChannel (channelId) {
      return PostWithAuth(getBaseURL() + `ModulesChatAuth/DeleteModulesChatsChannels/${channelId}`, '', store.getters.user.Token)
    },
    GetChatChannel (ModulesChatChannelId, SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModulesChatAuth/GetModulesChannels/${ModulesChatChannelId}/${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    SaveChatUserInfo (payload) {
      return Post(getBaseURL() + 'ModulesChatAuth/ModulesChatsUsers', payload)
    },
    HideChatMessage (payload) {
      return PostWithAuth(getBaseURL() + `ModulesChatAuth/hideMessage/${payload.msgId}/${payload.value}`, '', store.getters.user.Token).then(response => response.body)
    },
    DeleteChatMessage (chatMessageId) {
      return PostWithAuth(getBaseURL() + `ModulesChatAuth/deleteMessage/${chatMessageId}`, '', store.getters.user.Token).then(response => response.body)
    },
    BanChatUser (payload) {
      return PostWithAuth(getBaseURL() + `ModulesChatAuth/banuser/${payload.msgId}/${payload.value}`, '', store.getters.user.Token).then(response => response.body)
    },
    BlockChatUser (payload) {
      return PostWithAuth(getBaseURL() + `ModulesChatAuth/blockuser/${payload.msgId}/${payload.value}`, '', store.getters.user.Token).then(response => response.body)
    },
    GetCustomCodeInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModuleCustomCodeAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    // WebsiteUrlValid (payload) {
    //   return PostWithAuth(getBaseURL() + 'ModuleWebsiteAuth/IsUrlValid', payload, store.getters.user.Token).then(response => response)
    // },
    SaveCustomCodeInfo (payload) {
      return PostWithAuth(getBaseURL() + 'ModuleCustomCodeAuth', payload, store.getters.user.Token)
    },
    GetPDFModuleInfo (SubscriptionModuleId) {
      return GetWithAuth(getBaseURL() + `ModulePDFModelAuth?id=${SubscriptionModuleId}`, store.getters.user.Token).then(response => response.json())
    },
    SavePDFSettings (payload) {
      return PostWithAuth(getBaseURL() + 'ModulePDFModelAuth', payload, store.getters.user.Token)
    },
    DeletePDFFile (payload) {
      return PostWithAuth(getBaseURL() + 'ModulePDFModelAuth/DeletePDFFile', payload, store.getters.user.Token).then(response => response.json())
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/index.js